import React from 'react'
import {StyleSheet, View} from 'react-native'

import {type ComposerOpts} from '#/state/shell/composer'
import {
  EmojiPicker,
  type EmojiPickerPosition,
  type EmojiPickerState,
} from '#/view/com/composer/text-input/web/EmojiPicker'
import {ComposePost, useComposerCancelRef} from '#/view/com/composer/Composer'
import {atoms as a, useTheme, web} from '#/alf'

/**
 * Full ComposePost + emoji picker for the home feed tweet box (no modal shell).
 * Modal composer is rendered from `#/view/shell/Composer.web` when `presentation` is not `inline`.
 */
export function ComposerInline({state}: {state: ComposerOpts}) {
  const t = useTheme()
  const cancelRef = useComposerCancelRef()
  const [pickerState, setPickerState] = React.useState<EmojiPickerState>({
    isOpen: false,
    pos: {top: 0, left: 0, right: 0, bottom: 0, nextFocusRef: null},
  })

  const onOpenPicker = React.useCallback(
    (pos: EmojiPickerPosition | undefined) => {
      if (!pos) return
      setPickerState({
        isOpen: true,
        pos,
      })
    },
    [],
  )

  const onClosePicker = React.useCallback(() => {
    setPickerState(prev => ({
      ...prev,
      isOpen: false,
    }))
  }, [])

  return (
    <View
      style={[
        a.w_full,
        t.atoms.border_contrast_low,
        {
          borderBottomWidth: 2,
        },
        web({
          height: 520,
          maxHeight: '70vh',
        }),
      ]}>
      <View style={[a.w_full, a.flex_1, styles.composeShell, t.atoms.bg]}>
        <ComposePost
          cancelRef={cancelRef}
          replyTo={state.replyTo}
          quote={state.quote}
          onPost={state.onPost}
          onPostSuccess={state.onPostSuccess}
          mention={state.mention}
          openEmojiPicker={onOpenPicker}
          text={state.text}
          imageUris={state.imageUris}
          videoUri={state.videoUri}
          openGallery={state.openGallery}
          logContext={state.logContext}
        />
      </View>
      <EmojiPicker state={pickerState} close={onClosePicker} />
    </View>
  )
}

const styles = StyleSheet.create({
  composeShell: {
    minHeight: 280,
    overflow: 'hidden',
  },
})
